const list = [
  {
    desc: '亚洲',
    name: 'asia',
  },
  {
    desc: '欧洲',
    name: 'europe',
  },
  {
    desc: '北美洲',
    name: 'north_america',
  },
  {
    desc: '南美洲',
    name: 'south_america',
  },
  {
    desc: '非洲',
    name: 'africa',
  },
  {
    desc: '大洋洲',
    name: 'oceania',
  },
];

export const countryList = [
  {
    desc: '印度',
    name: 'IN',
    code: 'IN'
  },
  {
    desc: '印尼',
    name: 'ID',
    code: 'ID'
  },
  {
    desc: '马来西亚',
    name: 'MY',
    code: 'MY'
  },
  {
    desc: '泰国',
    name: 'TH',
    code: 'TH'
  },
  {
    desc: '加拿大',
    name: 'CA',
    code: 'CA'
  },
  {
    desc: '法国',
    name: 'FR',
    code: 'FR'
  },
  {
    desc: '德国',
    name: 'DE',
    code: 'DE'
  },
  {
    desc: '立陶宛',
    name: 'LT',
    code: 'LT'
  },
  {
    desc: '墨西哥',
    name: 'MX',
    code: 'MX'
  },
  {
    desc: '西班牙',
    name: 'ES',
    code: 'ES'
  },
  {
    desc: '埃塞俄比亚',
    name: 'ET',
    code: 'ET'
  },
  {
    desc: '荷兰',
    name: 'NL',
    code: 'NL'
  },
  {
    desc: '英国',
    name: 'GB',
    code: 'GB'
  },
  {
    desc: '阿联酋',
    name: 'AE',
    code: 'AE'
  },
  {
    desc: '澳大利亚',
    name: 'AU',
    code: 'AU'
  },
  {
    desc: '菲律宾',
    name: 'PH',
    code: 'PH'
  },
  {
    desc: '新加坡',
    name: 'SG',
    code: 'SG'
  },
  {
    desc: '孟加拉',
    name: 'BD',
    code: 'BD'
  },
  {
    desc: '柬埔寨',
    name: 'KH',
    code: 'KH'
  },
  {
    desc: '老挝',
    name: 'LA',
    code: 'LA'
  },
  {
    desc: '越南',
    name: 'VN',
    code: 'VN'
  },
  {
    desc: '马尔代夫',
    name: 'MV',
    code: 'MV'
  },
  {
    desc: '巴基斯坦',
    name: 'PK',
    code: 'PK'
  },
  {
    desc: '斯里兰卡',
    name: 'LK',
    code: 'LK'
  }
];

export const deelCountryList = [
  {
    name: 'Albania',
    desc: '阿尔巴尼亚',
    code: 'AL'
  },
  {
    name: 'Armenia',
    desc: '亚美尼亚',
    code: 'AM'
  },
  {
    name: 'Austria',
    desc: '奥地利',
    code: 'AT'
  },
  {
    name: 'Azerbaijan',
    desc: '阿塞拜疆',
    code: 'AZ'
  },
  {
    name: 'Belarus',
    desc: '白俄罗斯',
    code: 'BY'
  },
  {
    name: 'Bolivia',
    desc: '玻利维亚',
    code: 'BO'
  },
  {
    name: 'Bosnia and Herzegovina',
    desc: '波斯尼亚和黑塞哥维那',
    code: 'BA'
  },
  {
    name: 'Brazil',
    desc: '巴西',
    code: 'BR'
  },
  {
    name: 'Bulgaria',
    desc: '保加利亚',
    code: 'BG'
  },
  {
    name: 'Chile',
    desc: '智利',
    code: 'CL'
  },
  {
    name: 'Colombia',
    desc: '哥伦比亚',
    code: 'CO'
  },
  {
    name: 'Costa Rica',
    desc: '哥斯达黎加',
    code: 'CR'
  },
  {
    name: 'Cote D\'Ivoire',
    desc: '科特迪瓦',
    code: 'CI'
  },
  {
    name: 'Croatia',
    desc: '克罗地亚',
    code: 'HR'
  },
  {
    name: 'Cyprus',
    desc: '塞浦路斯',
    code: 'CY'
  },
  {
    name: 'Czech Republic',
    desc: '捷克共和国',
    code: 'CZ'
  },
  {
    name: 'Denmark',
    desc: '丹麦',
    code: 'DK'
  },
  {
    name: 'Dominican Republic',
    desc: '多米尼加共和国',
    code: 'DO'
  },
  {
    name: 'Ecuador',
    desc: '厄瓜多尔',
    code: 'EC'
  },
  {
    name: 'Egypt',
    desc: '埃及',
    code: 'EG'
  },
  {
    name: 'Estonia',
    desc: '爱沙尼亚',
    code: 'EE'
  },
  {
    name: 'Finland',
    desc: '芬兰',
    code: 'FI'
  },
  {
    name: 'Georgia',
    desc: '格鲁吉亚',
    code: 'GE'
  },
  {
    name: 'Greece',
    desc: '希腊',
    code: 'GR'
  },
  {
    name: 'Honduras',
    desc: '洪都拉斯',
    code: 'HN'
  },
  {
    name: 'Hong Kong',
    desc: '中国香港',
    code: 'HK'
  },
  {
    name: 'Hungary',
    desc: '匈牙利',
    code: 'HU'
  },
  {
    name: 'Indonesia',
    desc: '印度尼西亚',
    code: 'ID'
  },
  {
    name: 'Ireland',
    desc: '爱尔兰',
    code: 'IE'
  },
  {
    name: 'Israel',
    desc: '以色列',
    code: 'IL'
  },
  {
    name: 'Italy',
    desc: '意大利',
    code: 'IT'
  },
  {
    name: 'Japan',
    desc: '日本',
    code: 'JP'
  },
  {
    name: 'Kazakhstan',
    desc: '哈萨克斯坦',
    code: 'KZ'
  },
  {
    name: 'Kenya',
    desc: '肯尼亚',
    code: 'KE'
  },
  {
    name: 'Kosovo',
    desc: '科索沃',
    code: ''
  },
  {
    name: 'Latvia',
    desc: '拉脱维亚',
    code: 'LV'
  },
  {
    name: 'Morocco',
    desc: '摩洛哥',
    code: 'MA'
  },
  {
    name: 'New Zealand',
    desc: '新西兰',
    code: 'NZ'
  },
  {
    name: 'Nigeria',
    desc: '尼日利亚',
    code: 'NG'
  },
  {
    name: 'Norway',
    desc: '挪威',
    code: 'NO'
  },
  {
    name: 'Panama',
    desc: '巴拿马',
    code: 'PA'
  },
  {
    name: 'Peru',
    desc: '秘鲁',
    code: 'PE'
  },
  {
    name: 'Poland',
    desc: '波兰',
    code: 'PL'
  },
  {
    name: 'Portugal',
    desc: '葡萄牙',
    code: 'PT'
  },
  {
    name: 'Puerto Rico',
    desc: '波多黎各',
    code: 'PR'
  },
  {
    name: 'Romania',
    desc: '罗马尼亚',
    code: 'RO'
  },
  {
    name: 'Russia',
    desc: '俄罗斯',
    code: 'RU'
  },
  {
    name: 'Rwanda',
    desc: '卢旺达',
    code: 'RW'
  },
  {
    name: 'Serbia',
    desc: '塞尔维亚',
    code: 'RS'
  },
  {
    name: 'Slovakia',
    desc: '斯洛伐克',
    code: 'SK'
  },
  {
    name: 'Slovenia',
    desc: '斯洛文尼亚',
    code: 'SI'
  },
  {
    name: 'South Africa',
    desc: '南非',
    code: 'ZA'
  },
  {
    name: 'South Korea',
    desc: '韩国',
    code: 'KR'
  },
  {
    name: 'Sweden',
    desc: '瑞典',
    code: 'SE'
  },
  {
    name: 'Switzerland',
    desc: '瑞士',
    code: 'CH'
  },
  {
    name: 'Tunisia',
    desc: '突尼斯',
    code: 'TN'
  },
  {
    name: 'Turkey',
    desc: '土耳其',
    code: 'TR'
  },
  {
    name: 'Uganda',
    desc: '乌干达',
    code: 'UG'
  },
  {
    name: 'Ukraine',
    desc: '乌克兰',
    code: 'UA'
  },
  {
    name: 'United Arab Emirates',
    desc: '阿拉伯联合酋长国',
    code: 'AE'
  },
  {
    name: 'United States',
    desc: '美国',
    code: 'US'
  },
  {
    name: 'Uruguay',
    desc: '乌拉圭',
    code: 'UY'
  }
];

export default list;

export const Policies = [
  { name: 'Pay&Tax', desc: '工资和税收' },
  { name: 'Leave_Policy', desc: '休假政策' },
  { name: 'Statutory_time_off', desc: '法定休假' },
  { name: 'Onboarding', desc: '入职' },
  { name: 'Termination', desc: '解雇' },
  { name: 'Additional_info', desc: '附加信息' },
  { name: 'Country_profile', desc: '国家概况' },
  { name: 'Labor_employment_regulations', desc: '劳动就业法规' },
  { name: 'Labor_supply_demand_wages', desc: '劳动力供求及工薪' },
  { name: 'Corporate_tax', desc: '企业税收' },
  { name: 'Society_culture', desc: '社会文化' },
  { name: 'Banks_insurance_companies', desc: '银行和保险公司' },
  {
    name: 'Government_departments_relevant_institutions',
    desc: '政府部门和相关机构一览表',
  },
  { name: 'Political_environment', desc: '政治环境' },
];

export const blurList = [
  'Statutory_time_off',
  'Onboarding',
  'Termination',
  'Additional_info',
];

export function getDescByName(name: string, map = list) {
  const conf = map.find(item => item.name === name);
  if (!conf) {
    return '';
  }
  return conf.desc;
}

export function getNameByDesc(desc: string, map = list) {
  const conf = map.find(item => item.desc === desc);
  if (!conf) {
    return '';
  }
  return conf.name;
}

export const salaryToolCountryList = [
  {
    'label': '阿尔巴尼亚',
    'value': 'AL'
  },
  {
    'label': '亚美尼亚',
    'value': 'AM'
  },
  {
    'label': '澳大利亚',
    'value': 'AU'
  },
  {
    'label': '奥地利',
    'value': 'AT'
  },
  {
    'label': '白俄罗斯',
    'value': 'BY'
  },
  {
    'label': '比利时',
    'value': 'BE'
  },
  {
    'label': '波斯尼亚和黑塞哥维那',
    'value': 'BA'
  },
  {
    'label': '巴西',
    'value': 'BR'
  },
  {
    'label': '保加利亚',
    'value': 'BG'
  },
  {
    'label': '柬埔寨',
    'value': 'KH'
  },
  {
    'label': '加拿大',
    'value': 'CA'
  },
  {
    'label': '智利',
    'value': 'CL'
  },
  {
    'label': '中国',
    'value': 'CN'
  },
  {
    'label': '哥伦比亚',
    'value': 'CO'
  },
  {
    'label': '哥斯达黎加',
    'value': 'CR'
  },
  {
    'label': '克罗地亚',
    'value': 'HR'
  },
  {
    'label': '塞浦路斯',
    'value': 'CY'
  },
  {
    'label': '捷克共和国',
    'value': 'CZ'
  },
  {
    'label': '丹麦',
    'value': 'DK'
  },
  {
    'label': '多米尼加共和国',
    'value': 'DO'
  },
  {
    'label': '埃及',
    'value': 'EG'
  },
  {
    'label': '爱沙尼亚',
    'value': 'EE'
  },
  {
    'label': '芬兰',
    'value': 'FI'
  },
  {
    'label': '法国',
    'value': 'FR'
  },
  {
    'label': '格鲁吉亚',
    'value': 'GE'
  },
  {
    'label': '德国',
    'value': 'DE'
  },
  {
    'label': '希腊',
    'value': 'GR'
  },
  {
    'label': '洪都拉斯',
    'value': 'HN'
  },
  {
    'label': '香港',
    'value': 'HK'
  },
  {
    'label': '匈牙利',
    'value': 'HU'
  },
  {
    'label': '冰岛',
    'value': 'IS'
  },
  {
    'label': '印度',
    'value': 'IN'
  },
  {
    'label': '印度尼西亚',
    'value': 'ID'
  },
  {
    'label': '爱尔兰',
    'value': 'IE'
  },
  {
    'label': '以色列',
    'value': 'IL'
  },
  {
    'label': '意大利',
    'value': 'IT'
  },
  {
    'label': '日本',
    'value': 'JP'
  },
  {
    'label': '肯尼亚',
    'value': 'KE'
  },
  {
    'label': '科索沃',
    'value': 'XK'
  },
  {
    'label': '拉脱维亚',
    'value': 'LV'
  },
  {
    'label': '立陶宛',
    'value': 'LT'
  },
  {
    'label': '卢森堡',
    'value': 'LU'
  },
  {
    'label': '马达加斯加',
    'value': 'MG'
  },
  {
    'label': '马来西亚',
    'value': 'MY'
  },
  {
    'label': '马耳他',
    'value': 'MT'
  },
  {
    'label': '毛里求斯',
    'value': 'MU'
  },
  {
    'label': '墨西哥',
    'value': 'MX'
  },
  {
    'label': '蒙古',
    'value': 'MN'
  },
  {
    'label': '摩洛哥',
    'value': 'MA'
  },
  {
    'label': '荷兰',
    'value': 'NL'
  },
  {
    'label': '新西兰',
    'value': 'NZ'
  },
  {
    'label': '尼日利亚',
    'value': 'NG'
  },
  {
    'label': '北马其顿',
    'value': 'MK'
  },
  {
    'label': '挪威',
    'value': 'NO'
  },
  {
    'label': '巴基斯坦',
    'value': 'PK'
  },
  {
    'label': '巴拿马',
    'value': 'PA'
  },
  {
    'label': '秘鲁',
    'value': 'PE'
  },
  {
    'label': '菲律宾',
    'value': 'PH'
  },
  {
    'label': '波兰',
    'value': 'PL'
  },
  {
    'label': '葡萄牙',
    'value': 'PT'
  },
  {
    'label': '波多黎各',
    'value': 'PR'
  },
  {
    'label': '罗马尼亚',
    'value': 'RO'
  },
  {
    'label': '俄罗斯',
    'value': 'RU'
  },
  {
    'label': '卢旺达',
    'value': 'RW'
  },
  {
    'label': '塞尔维亚',
    'value': 'RS'
  },
  {
    'label': '新加坡',
    'value': 'SG'
  },
  {
    'label': '斯洛伐克',
    'value': 'SK'
  },
  {
    'label': '斯洛文尼亚',
    'value': 'SI'
  },
  {
    'label': '南非',
    'value': 'ZA'
  },
  {
    'label': '韩国',
    'value': 'KR'
  },
  {
    'label': '西班牙',
    'value': 'ES'
  },
  {
    'label': '斯里兰卡',
    'value': 'LK'
  },
  {
    'label': '瑞典',
    'value': 'SE'
  },
  {
    'label': '瑞士',
    'value': 'CH'
  },
  {
    'label': '台湾',
    'value': 'TW'
  },
  {
    'label': '泰国',
    'value': 'TH'
  },
  {
    'label': '突尼斯',
    'value': 'TN'
  },
  {
    'label': '土耳其',
    'value': 'TR'
  },
  {
    'label': '乌干达',
    'value': 'UG'
  },
  {
    'label': '乌克兰',
    'value': 'UA'
  },
  {
    'label': '阿拉伯联合酋长国',
    'value': 'AE'
  },
  {
    'label': '英国',
    'value': 'GB'
  },
  {
    'label': '美国',
    'value': 'US'
  },
  {
    'label': '乌拉圭',
    'value': 'UY'
  },
  {
    'label': '越南',
    'value': 'VN'
  }
];
export const salaryToolJobList = [
  {
    'label': '会计',
    'value': 'Accountant'
  },
  {
    'label': '账户主管',
    'value': 'Account Executive'
  },
  {
    'label': '账户经理',
    'value': 'Account Manager'
  },
  {
    'label': '应付账款助理',
    'value': 'Accounts Payable Assistant'
  },
  {
    'label': '账户专员',
    'value': 'Account Specialist'
  },
  {
    'label': '行政助理',
    'value': 'Administrative Assistant'
  },
  {
    'label': '高级顾问',
    'value': 'Advanced Consultant'
  },
  {
    'label': '算法工程师',
    'value': 'Algorithm Engineer'
  },
  {
    'label': '反洗钱分析师',
    'value': 'AML Analyst'
  },
  {
    'label': '分析师',
    'value': 'Analyst'
  },
  {
    'label': '区域经理',
    'value': 'Area Manager'
  },
  {
    'label': '装配线操作',
    'value': 'Assembly Line Operative'
  },
  {
    'label': '品牌经理助理',
    'value': 'Assistant Brand Manager'
  },
  {
    'label': '助理',
    'value': 'Assistant Manager'
  },
  {
    'label': '副总裁助理',
    'value': 'Assistant  Vice President'
  },
  {
    'label': '合伙人',
    'value': 'Associate'
  },
  {
    'label': '审计助理',
    'value': 'Audit Associate'
  },
  {
    'label': '审计师',
    'value': 'Auditor'
  },
  {
    'label': '后端开发人员',
    'value': 'Back-end Developer'
  },
  {
    'label': '后端工程师',
    'value': 'Back-end Engineer'
  },
  {
    'label': '品牌经理',
    'value': 'Brand Manager'
  },
  {
    'label': '业务分析师',
    'value': 'Business Analyst'
  },
  {
    'label': '商业顾问',
    'value': 'Business Consultant'
  },
  {
    'label': '业务发展',
    'value': 'Business Development'
  },
  {
    'label': '业务发展主管',
    'value': 'Business Development Executive'
  },
  {
    'label': '业务发展经理',
    'value': 'Business Development Manager'
  },
  {
    'label': '客舱乘务员',
    'value': 'Cabin Crew'
  },
  {
    'label': 'CEO',
    'value': 'CEO'
  },
  {
    'label': '理赔处理人',
    'value': 'Claims Handler'
  },
  {
    'label': '客户经理',
    'value': 'Client Manager'
  },
  {
    'label': '客户服务助理',
    'value': 'Client Service Associate'
  },
  {
    'label': '客户服务代表',
    'value': 'Client Service Representative'
  },
  {
    'label': '客户服务经理',
    'value': 'Client Services Manager'
  },
  {
    'label': '临床研究助理',
    'value': 'Clinical Research Associate'
  },
  {
    'label': '云解决方案架构师',
    'value': 'Cloud Solution Architect'
  },
  {
    'label': '社区经理',
    'value': 'Community Manager'
  },
  {
    'label': '顾问',
    'value': 'Consultant'
  },
  {
    'label': '内容营销经理',
    'value': 'Content Manager'
  },
  {
    'label': '内容编辑',
    'value': 'Content Writer'
  },
  {
    'label': '信贷管理员',
    'value': 'Credit Controller'
  },
  {
    'label': '客服',
    'value': 'Customer Assistant'
  },
  {
    'label': '客户业务分析师',
    'value': 'Customer Business Analyst'
  },
  {
    'label': '客户关系协调员',
    'value': 'Customer Care Coordinator'
  },
  {
    'label': '客户服务专员',
    'value': 'Customer Service'
  },
  {
    'label': '客户服务顾问',
    'value': 'Customer Service Advisor'
  },
  {
    'label': '客户服务代表',
    'value': 'Customer Service Representative'
  },
  {
    'label': '客户成功经理',
    'value': 'Customer Success Manager'
  },
  {
    'label': '客户支持',
    'value': 'Customer Support'
  },
  {
    'label': '数据分析师',
    'value': 'Data Analyst'
  },
  {
    'label': '数据工程师',
    'value': 'Data Engineer'
  },
  {
    'label': '数据输入操作员',
    'value': 'Data Entry'
  },
  {
    'label': '数据科学家',
    'value': 'Data Scientist'
  },
  {
    'label': '工程设计师',
    'value': 'Design Engineer'
  },
  {
    'label': '设计师',
    'value': 'Designer'
  },
  {
    'label': '开发人员',
    'value': 'Developer'
  },
  {
    'label': 'DevOps工程师',
    'value': 'DevOps Engineer'
  },
  {
    'label': '编辑',
    'value': 'Editor'
  },
  {
    'label': '项目经理',
    'value': 'Engagement Manager'
  },
  {
    'label': '工程师',
    'value': 'Engineer'
  },
  {
    'label': '企业客户主管',
    'value': 'Enterprise Account Executive'
  },
  {
    'label': '行政助理',
    'value': 'Executive Assistant'
  },
  {
    'label': '外勤服务工程师',
    'value': 'Field Engineer'
  },
  {
    'label': '现场维修工程师',
    'value': 'Field Service Engineer'
  },
  {
    'label': '财务助理',
    'value': 'Finance Assistant'
  },
  {
    'label': '财务经理',
    'value': 'Finance Manager'
  },
  {
    'label': '财务分析师',
    'value': 'Financial Analyst'
  },
  {
    'label': '餐饮代理',
    'value': 'Food and Beverage Associate'
  },
  {
    'label': '前台接待',
    'value': 'Front Desk Agent'
  },
  {
    'label': '前端开发人员',
    'value': 'Front-end Developer'
  },
  {
    'label': '前端工程师',
    'value': 'Front-end Engineer'
  },
  {
    'label': '全栈开发人员',
    'value': 'Full-stack Developer'
  },
  {
    'label': '全栈工程师',
    'value': 'Full-stack Engineer'
  },
  {
    'label': '总经理',
    'value': 'General Manager'
  },
  {
    'label': '见习土木工程师',
    'value': 'Graduate Civil Engineer'
  },
  {
    'label': '见习工程师',
    'value': 'Graduate Engineer'
  },
  {
    'label': '毕业生招聘顾问',
    'value': 'Graduate Recruitment Consultant'
  },
  {
    'label': '平面设计师',
    'value': 'Graphic Designer'
  },
  {
    'label': '人力资源经理',
    'value': 'HR Manager'
  },
  {
    'label': '管培生',
    'value': 'Industrial Placement Student'
  },
  {
    'label': '内部销售代表',
    'value': 'Inside Sales Representative'
  },
  {
    'label': '中级应用程序开发人员',
    'value': 'Intermediate Applications Developer'
  },
  {
    'label': '实习生',
    'value': 'Intern'
  },
  {
    'label': '内部技术支持工程师',
    'value': 'Internal Technical Support Engineer'
  },
  {
    'label': 'IOS工程师',
    'value': 'IOS Engineer'
  },
  {
    'label': '知识产权专家',
    'value': 'IP Expert'
  },
  {
    'label': 'IT项目经理',
    'value': 'IT Project Manager'
  },
  {
    'label': 'Java开发人员',
    'value': 'Java Developer'
  },
  {
    'label': '大客户经理',
    'value': 'Key Account Manager'
  },
  {
    'label': 'Kyc分析师',
    'value': 'Kyc Analyst'
  },
  {
    'label': '实验室技术员',
    'value': 'Laboratory Technician'
  },
  {
    'label': '法律秘书',
    'value': 'Legal Secretary'
  },
  {
    'label': '管理顾问',
    'value': 'Managing Consultant'
  },
  {
    'label': '制造技术员',
    'value': 'Manufacturing Technician'
  },
  {
    'label': '市场营销',
    'value': 'Marketing'
  },
  {
    'label': '营销主管',
    'value': 'Marketing Executive'
  },
  {
    'label': '营销经理',
    'value': 'Marketing Manager'
  },
  {
    'label': '机械工程师',
    'value': 'Mechanical Engineer'
  },
  {
    'label': '医疗顾问',
    'value': 'Medical Advisor'
  },
  {
    'label': '区域医学顾问',
    'value': 'Medical Science Liaison'
  },
  {
    'label': '医学撰稿专员',
    'value': 'Medical Writer'
  },
  {
    'label': '全国客户经理',
    'value': 'National Account Manager'
  },
  {
    'label': '夜间审计员',
    'value': 'Night Auditor'
  },
  {
    'label': '办公室经理',
    'value': 'Office Manager'
  },
  {
    'label': '运营分析师',
    'value': 'Operations Analyst'
  },
  {
    'label': '运营助理',
    'value': 'Operations Associate'
  },
  {
    'label': '运营经理',
    'value': 'Operations Manager'
  },
  {
    'label': '运营支持',
    'value': 'Operations Support'
  },
  {
    'label': '海外销售代表',
    'value': 'Outbound Sales Representative'
  },
  {
    'label': '首席科学家',
    'value': 'Principal Scientist'
  },
  {
    'label': '工艺工程师',
    'value': 'Process Engineer'
  },
  {
    'label': '产品设计师',
    'value': 'Product Designer'
  },
  {
    'label': '生产工程师',
    'value': 'Production Engineer'
  },
  {
    'label': '产品经理',
    'value': 'Product Manager'
  },
  {
    'label': '产品负责人',
    'value': 'Product Owner'
  },
  {
    'label': '项目经理',
    'value': 'Program Manager'
  },
  {
    'label': '程序员',
    'value': 'Programmer'
  },
  {
    'label': '项目工程师',
    'value': 'Project Engineer'
  },
  {
    'label': '产品经理',
    'value': 'Project Manager'
  },
  {
    'label': '质量保证工程师',
    'value': 'QA Engineer'
  },
  {
    'label': '招聘人员',
    'value': 'Recruiter'
  },
  {
    'label': '招聘顾问',
    'value': 'Recruitment Consultant'
  },
  {
    'label': '关系经理',
    'value': 'Relationship Manager'
  },
  {
    'label': '研究分析师',
    'value': 'Research Analyst'
  },
  {
    'label': '研究助理',
    'value': 'Research Assistant'
  },
  {
    'label': '助理研究院员',
    'value': 'Research Associate'
  },
  {
    'label': '研究员',
    'value': 'Researcher'
  },
  {
    'label': '研究科学家',
    'value': 'Research Scientist'
  },
  {
    'label': '零售销售助理',
    'value': 'Retail Sales Associate'
  },
  {
    'label': '收益经理',
    'value': 'Revenue Manager'
  },
  {
    'label': '店铺销售顾问',
    'value': 'Sales Advisor'
  },
  {
    'label': '销售助理',
    'value': 'Sales Assistant'
  },
  {
    'label': '销售员',
    'value': 'Sales Associate'
  },
  {
    'label': '销售顾问',
    'value': 'Sales Consultant'
  },
  {
    'label': '销售开发代表',
    'value': 'Sales Development Representative'
  },
  {
    'label': '销售主管',
    'value': 'Sales Executive'
  },
  {
    'label': '销售经理',
    'value': 'Sales Manager'
  },
  {
    'label': '销售代表',
    'value': 'Sales Representative'
  },
  {
    'label': '销售专员',
    'value': 'Sales Specialist'
  },
  {
    'label': '科学家',
    'value': 'Scientist'
  },
  {
    'label': '社交媒体经理',
    'value': 'Social Media Manager'
  },
  {
    'label': '软件开发人员',
    'value': 'Software Developer'
  },
  {
    'label': '软件工程师',
    'value': 'Software Engineer'
  },
  {
    'label': '软件工程经理',
    'value': 'Software Engineering Manager'
  },
  {
    'label': '解决方案架构师',
    'value': 'Solutions Architect'
  },
  {
    'label': '统计专员',
    'value': 'Statistician'
  },
  {
    'label': '门店经理',
    'value': 'Store Manager'
  },
  {
    'label': '行业专家',
    'value': 'Subject Matter Expert'
  },
  {
    'label': '字幕员',
    'value': 'Subtitler'
  },
  {
    'label': '暑期实习生',
    'value': 'Summer Analyst'
  },
  {
    'label': '主管',
    'value': 'Supervisor'
  },
  {
    'label': '护工',
    'value': 'Support Worker'
  },
  {
    'label': '系统工程师',
    'value': 'Systems Engineer'
  },
  {
    'label': '教师',
    'value': 'Teacher'
  },
  {
    'label': '技术销售专员',
    'value': 'Technical Sales Specialist'
  },
  {
    'label': '技术支持工程师',
    'value': 'Technical Support Engineer'
  },
  {
    'label': '临时行政',
    'value': 'Temporary Administrative'
  },
  {
    'label': '区域经理',
    'value': 'Territory Manager'
  },
  {
    'label': '测试分析师',
    'value': 'Test Analyst'
  },
  {
    'label': '交易员',
    'value': 'Trader'
  },
  {
    'label': 'UI/UX设计师',
    'value': 'UI/UX Designer'
  },
  {
    'label': '视频编辑器',
    'value': 'Video Editor'
  },
  {
    'label': '虚拟助理',
    'value': 'Virtual Assistant'
  },
  {
    'label': '仓库助理',
    'value': 'Warehouse Associate'
  },
  {
    'label': '仓库工人',
    'value': 'Warehouse Worker'
  }
];
